import {isDefinedAndPopulated} from 'GlobalShared/utils/typeGuards';

import type {ImageUpload} from 'types/payload-types';

/**
 * The `useStorePartner` hook extracts and normalizes logo metadata from a store partner media object.
 * It checks whether the provided logo is a fully populated `Media` object and, if so, extracts its URL, width, and height.
 * If the logo is a plain string or not populated, the returned properties will remain undefined.
 *
 * @param logo The store partner logo, either as a populated `Media` object containing image metadata or as a raw string identifier.
 * @returns An object containing the `logoUrl`, `width`, and `height` of the logo if the media is populated, otherwise undefined values.
 *
 * @example
 * ```tsx
 * const {logoUrl, width, height} = useStorePartner(storePartner.logo);
 * ```
 */
export const useStorePartner = (logo?: ImageUpload) => {
    let alt;
    let logoUrl;
    let width;
    let height;

    if (isDefinedAndPopulated(logo?.image)) {
        alt = logo.alt;
        logoUrl = logo.image.url;
        width = logo.image.width;
        height = logo.image.height;
    }

    return {
        alt,
        height,
        logoUrl,
        width
    };
};